import { isCancel } from 'axios';
import * as projectApi from './project';
import cachesApi from './caches';
import userApi from './user';
import verifyApi from './verify';
import preferentialApi from './preferential';
import baseApi from './base';
import orderApi from './order';
import storeApi from './store';
import menuApi from './menu';

export default {
  project: projectApi,
  caches: cachesApi,
  user: userApi,
  verify: verifyApi,
  preferential: preferentialApi,
  base: baseApi,
  order: orderApi,
  store: storeApi,
  menu: menuApi,
  isCancel,
};
